import { render } from "./EnvelopeIcon.vue?vue&type=template&id=e76cf00a"
import script from "./EnvelopeIcon.vue?vue&type=script&lang=js"
export * from "./EnvelopeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__